import { Component } from '@angular/core';
import { LacertaDynamicTypeComponent } from '@lacerta/cms';
import { VervitGalleryBlock } from '@lacerta/vervit/feature-shell';

@Component({
  template: ` <setis-gallery [images]="context"></setis-gallery> `,
})
export class SetisWagtailGalleryComponent extends LacertaDynamicTypeComponent<VervitGalleryBlock> {}
